import { render, staticRenderFns } from "./SupportTicketChats.vue?vue&type=template&id=796a6f2c&scoped=true"
import script from "./SupportTicketChats.vue?vue&type=script&lang=js"
export * from "./SupportTicketChats.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketChats.vue?vue&type=style&index=0&id=796a6f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a6f2c",
  null
  
)

export default component.exports